module.exports = __webpack_public_path__ + "static/Depositphotos_26671801_m-2015-8ebdce7105a0c2c95b8ebd4dbb288347.webp";